module.exports = __webpack_public_path__ + "components/country-flag/static/ly-2a8757130e925126837649658a91d076.svg";